import axios from "axios";
import { saveFile } from "../native/files";

const openPdfMobile = (base64String) => {
    const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Invoice</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { width: 100vw; height: 100vh; overflow: hidden; }
          iframe { width: 100%; height: 100%; border: none; }
        </style>
      </head>
      <body>
        <iframe src="${base64String}"></iframe>
      </body>
    </html>
  `;

    const blob = new Blob([html], { type: "text/html" });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");

    setTimeout(() => URL.revokeObjectURL(blobUrl), 30000);
};

/**
 * Downloads (or on native, opens) the invoice PDF. `lang` other than "de" prints a translation.
 * Returns { translation }: "partial" when the server could not translate the typed texts.
 */
export const downloadInvoice = async (invoiceId, setLoading, { lang, fileName } = {}) => {
    if (setLoading) setLoading(true);

    try {
        const token = localStorage.getItem("token");
        const query = lang && lang !== "de" ? `?lang=${encodeURIComponent(lang)}` : "";
        const url = `${process.env.REACT_APP_BACKEND_URL}/invoices/invoice/download/${invoiceId}${query}`;
        const name = `${fileName || `Rechnung-${invoiceId}`}.pdf`;

        const response = await fetch(url, {
            headers: { Authorization: "Bearer " + token }
        });

        if (!response.ok) throw new Error("Failed to generate PDF");

        const blob = await response.blob();

        const base64String = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: "DOWNLOAD_PDF",
                data: base64String,
                filename: name
            }));
        } else {
            const pdfBlob = new Blob([blob], { type: "application/pdf" });
            await saveFile(pdfBlob, name);
        }

        return { translation: response.headers.get("X-Translation") || "complete" };

    } catch (error) {
        console.error("Error downloading PDF:", error);
        throw error;
    } finally {
        if (setLoading) setLoading(false);
    }
};